import { Component, Output, Input, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { BackendService } from 'src/app/services/backend.service';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'select-institutions',
  templateUrl: './select-institutions.component.html',
  styleUrls: ['./select-institutions.component.scss']
})
export class SelectInstitutionsComponent{

  @Input() public institutions: Array<any>;
  @Input() public selected_institutions: Array<any>;
  @Output() SelectedInstitutionsChange = new EventEmitter();


  public error: boolean;
  public cargado: boolean;
  public actualizando: boolean;
  public originalLen: number;

  constructor(){
    /*this.selected_institutions = new Array<any>();
    this.selected_institutions.push("");*/
    this.actualizando = false;
    this.originalLen = 0;
  }

  ngOnInit(){
    console.log('Cargado select-institutions.component.ts');
    console.log('Instituciones para seleccionar');
    console.log(this.institutions);
    console.log('Instituciones seleccionadas');
    console.log(this.selected_institutions);
  }
  
  // metodo que se llama cuando se envía el formulario
  guardarSeleccion(){
    // emitir un evento Output
    console.log("en submit");
    if (this.selected_institutions[this.selected_institutions.length-1]=='0' && this.selected_institutions.length > 1){
      this.selected_institutions.pop();
    }
    this.SelectedInstitutionsChange.emit({selected_institutions: this.selected_institutions});
  }

  numeroInstitucionesSeleccionadas():number{
    return this.selected_institutions.length;
  }



  anadirNivel(){
    this.selected_institutions.push('0');
  }

  eliminarNivel(index:number){
    console.log("EN eliminar");
    console.log(this.selected_institutions);
    this.selected_institutions.splice(index,1);
    console.log(this.selected_institutions);
  }

  trackByFn(index:any, item:any){
    return index;
  }

  addedWithoutSelected(){
    if (this.selected_institutions.includes('0')){
      return true;
    } else {
      return false;
    }
  }

  inOtherSelectedYet(institution_number,i){
    let index = this.selected_institutions.indexOf(String(institution_number));
    if (index>=0 && index!=i){
      return true;
    }
    else{
      return false;
    }
  }



}
